module.exports = __webpack_public_path__ + "media/images/flags/1x1/alb-c999396576eb779fd97d33bd1234575f.svg";